import { BaseRatesApiRepository } from "@/app/infrastructures/repositories/api/BaseRatesApiRepository";
import { ListRatesApiRequest } from "@/data/payload/api/BaseRatesApiRequest";
import { ChangeBaseRatesRequestInterface } from "@/data/payload/contracts/BaseRatesRequest";
import { BaseRatesEntities, RatesDetail } from "@/domain/entities/BaseRates";
import { ResponsePayload } from "@/domain/entities/ResponsePayload";
import { injectable } from "tsyringe";

@injectable()
export class BaseRatesPresenter {
  private repository: BaseRatesApiRepository;

  constructor(repo: BaseRatesApiRepository) {
    this.repository = repo;
  }

  public getBaseRatesList(
    search: string,
    status: string,
    page: number,
    limit: number
  ): Promise<BaseRatesEntities> {
    return this.repository.getBaseRatesList(search, status, page, limit);
  }

  public getRatesList(params: ListRatesApiRequest): Promise<BaseRatesEntities> {
    return this.repository.getRatesList(params);
  }

  public getDetailRates(id: number): Promise<RatesDetail> {
    return this.repository.getDetail(id);
  }

  public editBaseRates(
    id: number,
    payload: ChangeBaseRatesRequestInterface
  ): Promise<ResponsePayload> {
    return this.repository.editBaseRates(id, payload);
  }
}
